<template>
  <div class="list">
    <!-- header-title -->
    <div class="header-title flex-row flex__between margin-bottom-10">
      <div class="leftSection flex-row flex__left">
        <div class="theTitle theTitle__lv1 flex-row flex__left padding-left-10">Thông tin văn bản</div>
        <div class="theTitle theTitle__lv3 flex-row flex__left">Đơn vị trình</div>
        <div class="theTitle theTitle__lv3 flex-row flex__left">Ngày trình, Ngày trả</div>
        <div class="theTitle theTitle__lv1 flex-row flex__left">Đơn vị nhận VB trả ra</div>
        <div class="theTitle theTitle__lv1 flex-row flex__left">DS Lãnh đạo trình</div>
        <div class="theTitle theTitle__lv3 flex-row flex__left">Trạng thái</div>
      </div>
    </div>
    <!-- list-docs -->
    <VuePerfectScrollbar class="scroll-area" :settings="perfectScrollbarSetting" infinite-wrapper>
      <div class="list-docs">
        <div class="item flex-row flex__between" v-for="(item, $itemIndex) in this.data" v-bind:key="$itemIndex">
          <div class="leftSection flex-row flex__left">

            <div class="theTitle__lv1 padding-left-10">
              <div class="title-docs flex-col flex__left">
                <div>
                  <div style="word-break: break-word;"><b>Trích yếu</b>: {{item.hcCaseDoc.brief}}</div>
                  <div><b>Loại văn bản</b>: {{item.hcCaseDoc.docTypeName}}</div>
                  <div><b>Số văn bản</b>: {{item.hcCaseDoc.docNum}}</div>
                  <div><b>Ngày văn bản</b>: {{item.hcCaseDoc.docDate}}</div>
                </div>
              </div>
            </div>

            <div class="theTitle__lv3">
              <div class="title-docs flex-col flex__left">
                <div>
                  {{item.hcCaseDoc.requestDeptName}}
                </div>
              </div>
            </div>

            <div class="theTitle__lv3">
              <div class="title-docs flex-col flex__left">
                <div>
                  {{item.hcCaseDoc.createTime}}<br>{{item.hcCaseDoc.returnDate}}
                </div>
              </div>
            </div>

            <div class="theTitle__lv1">
              <div class="title-docs flex-col flex__left">
                <div>
                  <div style="word-break: break-word;" v-for="(it, $i) in item.hcCaseDocOrgs" v-bind:key="$i">
                    {{it.returnDeptName}}<br>{{timeReturn(it.orgReceivedDate)}}
                  </div>
                </div>
              </div>
            </div>

            <div class="theTitle__lv1">
              <div class="title-docs flex-col flex__left">
                <div v-for="(it, $i) in item.hcCaseDocApprovers" v-bind:key="$i">
                  <el-tag :class="['priority', colorStateTrinhTra(it)]">{{stateTrinhTra(it)}}</el-tag>
                  - {{it.approverFullname}} {{timeTrinhTra(it)}}
                </div>
              </div>
            </div>

            <div class="theTitle__lv3">
              <div class="title-docs flex-col flex__left">
                <div>
                  <el-tag :class="['priority', colorState(item.hcCaseDoc.state)]">{{item.hcCaseDoc.state}}</el-tag>
                </div>
              </div>
            </div>

          </div>

          <div class="rightSection flex-row flex__left">

            <div class="theQuickAction flex-row flex__right">
              <el-tooltip content="Trình văn bản" placement="top" v-if="vIfViewDetailSteps(item)">
                <i
                  @click.stop="viewDetailSteps(item)"
                  class="action-icon bgAmbient__blue clickable fas fa-retweet"
                ></i>
              </el-tooltip>
              <el-tooltip content="Trả văn bản" placement="top" v-if="vIfViewDetailReturn(item)">
                <i
                  @click.stop="viewDetailReturn(item)"
                  class="action-icon bgAmbient__blue clickable fas fa-edit"
                ></i>
              </el-tooltip>
              <el-tooltip content="Nhận văn bản" placement="top" v-if="vIfNhanVanBan(item)">
                <i
                  @click.stop="nhanVanBan(item)"
                  class="action-icon bgAmbient__blue clickable fas fa-arrow-circle-right"
                ></i>
              </el-tooltip>
              <el-tooltip content="Đơn vị nhận văn bản" placement="top" v-if="vIfDonViNhanVanBan(item)">
                <i
                  @click.stop="donViNhanVanBan(item)"
                  class="action-icon bgAmbient__blue clickable fas fa-check"
                ></i>
              </el-tooltip>
              <el-tooltip content="Báo cáo" placement="top" v-if="vIfDonViBaoCao(item)">
                <i
                  @click.stop="donViBaoCao(item)"
                  class="action-icon bgAmbient__blue clickable fas fa-share-square"
                ></i>
              </el-tooltip>
              <el-tooltip content="Hủy văn bản" placement="top" v-if="vIfHuyVanBan(item)">
                <i
                  @click.stop="huyVanBan(item)"
                  class="action-icon bgAmbient__blue clickable fas fa-trash"
                ></i>
              </el-tooltip>
              <el-tooltip content="Chi tiết" placement="top" v-if="vIfViewDetail(item)">
                <i
                  @click.stop="viewDetail(item)"
                  class="action-icon bgAmbient__blue clickable fas fa-eye"
                ></i>
              </el-tooltip>
              <el-tooltip content="Lịch sử tác động" placement="top" v-if="vIfViewDetailHistory(item)">
                <i
                  @click.stop="viewDetailHistory(item)"
                  class="action-icon bgAmbient__blue clickable fas fa-history"
                ></i>
              </el-tooltip>
            </div>


          </div>
        </div>

        <infinite-loading ref="infiniteLoading" spinner="spiral" @infinite="infiniteHandler">
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
        <div class="flex-row flex__center" v-if="this.data.length === 0">Không có dữ liệu</div>
      </div>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
    import VuePerfectScrollbar from "vue-perfect-scrollbar";
    import dateFormatter from "../../../filters/dateFormatter";
    import moment from "moment";
    import h from "../../../services/h";

    export default {
        name: "luongVb_MainContent",
        props: ["data", "hcFlow"],
        components: {
            VuePerfectScrollbar
        },
        filters: {dateFormatter},
        data() {
            return {};
        },
        computed: {
            currentDeptId() {
                let userDeptRole = h.find(
                    this.$store.state.userDeptRoles,
                    userDeptRole => userDeptRole.id === this.$store.getters.userDeptRoleId
                );
                return userDeptRole.deptId;
            }
        },
        methods: {
            viewDetail(item) {
                this.$emit("viewDetail", {
                    item: item
                });
            },
            viewDetailSteps(item) {
                this.$emit("viewDetailSteps", {
                    item: item
                });
            },
            viewDetailHistory(item) {
                this.$emit("viewDetailHistory", {
                    item: item
                });
            },
            viewDetailReturn(item) {
                this.$emit("viewDetailReturn", {
                    item: item
                });
            },
            nhanVanBan(item) {
                this.$emit("nhanVanBan", {
                    item: item
                });
            },
            huyVanBan(item) {
                this.$emit("huyVanBan", {
                    item: item
                });
            },
            donViNhanVanBan(item) {
                this.$emit("donViNhanVanBan", {
                    item: item
                });
            },
            donViBaoCao(item) {
                this.$emit("donViBaoCao", {
                    item: item
                });
            },

            infiniteHandler($state) {
                this.$emit("infiniteHandler", $state);
            },

            stateTrinhTra(hcCaseDocApproverItem) {
                if (hcCaseDocApproverItem.requestedStatus == 0 && hcCaseDocApproverItem.receivedStatus == 0) return "Chưa trình";
                if (hcCaseDocApproverItem.requestedStatus == 1 && hcCaseDocApproverItem.receivedStatus == 0) return "Đã trình";
                if (hcCaseDocApproverItem.requestedStatus == 1 && hcCaseDocApproverItem.receivedStatus == 1) return "Đã trả";
            },
            colorStateTrinhTra(hcCaseDocApproverItem) {
                if (hcCaseDocApproverItem.requestedStatus == 0 && hcCaseDocApproverItem.receivedStatus == 0) return "lv2";
                if (hcCaseDocApproverItem.requestedStatus == 1 && hcCaseDocApproverItem.receivedStatus == 0) return "lv2";
                if (hcCaseDocApproverItem.requestedStatus == 1 && hcCaseDocApproverItem.receivedStatus == 1) return "lv4";
            },
            timeTrinhTra(hcCaseDocApproverItem) {
                let requestedDate = moment(hcCaseDocApproverItem.requestedDate).format("DD/MM/YYYY HH:mm");
                let receivedDate = moment(hcCaseDocApproverItem.receivedDate).format("DD/MM/YYYY HH:mm");

                if (hcCaseDocApproverItem.requestedStatus == 0 && hcCaseDocApproverItem.receivedStatus == 0) return "";
                if (hcCaseDocApproverItem.requestedStatus == 1 && hcCaseDocApproverItem.receivedStatus == 0) return ": " + requestedDate;
                if (hcCaseDocApproverItem.requestedStatus == 1 && hcCaseDocApproverItem.receivedStatus == 1) return ": " + receivedDate;
            },
            timeReturn(date) {
                return date ? moment(date).format("DD/MM/YYYY HH:mm") : "";
            },
            colorState(state) {
                if (state == "Chờ nhận văn bản") return "lv2";
                if (state == "Đang trình") return "lv2";
                if (state == "Đã trả") return "lv2";
                if (state == "Hoàn thành") return "lv4";
                if (state == "Hủy văn bản") return "lv1";
            },
            vIfViewDetailSteps(item) {
                return item.hcCaseDoc.state === 'Đang trình' && this.hcFlow == null;
            },
            vIfViewDetailReturn(item) {
                return item.hcCaseDoc.state === 'Đang trình' && this.hcFlow == null;
            },
            vIfViewDetailHistory(item) {
                return false;
            },
            vIfViewDetail(item) {
                return true;
            },
            vIfNhanVanBan(item) {
                return item.hcCaseDoc.state === 'Chờ nhận văn bản' && this.hcFlow == null;
            },
            vIfHuyVanBan(item) {
                return item.hcCaseDoc.state === 'Chờ nhận văn bản';
            },
            vIfDonViNhanVanBan(item) {
                // Neu co it nhat 1 yeu cau tra ra: can bao cao + chua duoc nhan + chi dao cua don vi minh => hien thi
                if (this.hcFlow == null) {
                    return false;
                }
                let yeuCauTraRa = item.hcCaseDocOrgs;

                for (var i = 0; i < yeuCauTraRa.length; i++) {
                    if (yeuCauTraRa[i].isNeedReport == 1 && yeuCauTraRa[i].orgStatus == 0 && yeuCauTraRa[i].returnDeptId == this.currentDeptId) {
                        return true;
                    }
                }
                return false;
            },
            vIfDonViBaoCao(item) {
                // Neu co it nhat 1 yeu cau tra ra: can bao cao + da nhan + chua hoan thanh bao cao + chi dao cua don vi minh => hien thi
                if (this.hcFlow == null) return false;
                let yeuCauTraRa = item.hcCaseDocOrgs;

                for (var i = 0; i < yeuCauTraRa.length; i++) {
                    if (yeuCauTraRa[i].isNeedReport == 1 && yeuCauTraRa[i].orgStatus == 1 && yeuCauTraRa[i].sysStatus == 0 && yeuCauTraRa[i].returnDeptId == this.currentDeptId) {
                        return true;
                    }
                }
                return false;
            }
        },

        watch: {
            data(newValue) {
                if (newValue !== this.data) {
                    this.data = newValue;
                }
            }
        }
    };
</script>

<style scoped>
  .list {
    height: calc(100% - 50px - 15px) !important;
  }

  .icon_action {
    font-size: 15px;
    padding: 10px;
  }

  .icon_action:hover {
    background: white;
    box-shadow: 0 8px 15px rgba(39, 124, 190, 0.25);
  }

  .list .list-docs .item .priority.lv2 {
    display: inline;
    padding: 2px 7px;
    border: 1px solid #ff9900;
  }

  .list .list-docs .item .priority.lv4 {
    display: inline;
    padding: 2px 7px;
    border: 1px solid var(--color-green);
  }

  .list .list-docs .item .priority.lv1 {
    display: inline;
    padding: 2px 7px;
    border: 1px solid var(--color-red);
  }

  .priority.lv2 {
    color: #ff9900;
  }
</style>



// WEBPACK FOOTER //
// src/views/adminstration/luongvanban/luongVb_MainContent.vue